import { CircleAlert, Info } from 'lucide-react'
import styled from 'styled-components'

export const ConfirmBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  background: ${({ theme }) => `${theme.forecast.primary}2E`};
  border: 1px solid ${({ theme }) => `${theme.forecast.primary}73`};
  color: ${({ theme }) => theme.forecast.defaultText};
`

export const WarningBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  background: rgba(234, 179, 8, 0.16);
  border: 1px solid rgba(234, 179, 8, 0.45);
  color: ${({ theme }) => theme.forecast.defaultText};
`

export const EvalStatusRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`

export const BannerIcon = styled(Info)`
  flex-shrink: 0;
  margin-top: 0.125rem;
  color: ${({ theme }) => theme.forecast.primary};
`

export const WarningIcon = styled(CircleAlert)`
  flex-shrink: 0;
  margin-top: 0.125rem;
  color: #ca8a04;
`
